const data = {
  pageName: "MarketPlace",
  paymentCanceled: false,
  errorMsg: "",

  services: {
    marketPlaceSubmit: {
      url: "marketPlace/submitData",
      params: {}
    },
    marketPlaceTroubleTicketSubmit: {
      url: "marketPlace/troubleTicketSubmitData",
      params: {}
    },
    marketPlaceDetails: {
      url: "marketPlace/getDetails",
      params: {}
    },
    translations: {
      url: "marketPlace/translations",
      params: {}
    }
  }
};

exports.data = data;
